import { useState, useEffect, useRef } from 'react';
import { Container, Grid } from '@mui/material';
import '../styles.scss';

export default function Pregunta4({ setRespuesta, cambiarPregunta, sumarPuntos }) {
	const containerRef2 = useRef(null);

	const [connections, setConnections] = useState([
		{ from: '', to: '' },
		{ from: '', to: '' },
		{ from: '', to: '' },
		{ from: '', to: '' },
	]);
	const [btn1, setBtn1] = useState('');
	const [btn2, setBtn2] = useState('');
	const [btn3, setBtn3] = useState('');
	const [btn4, setBtn4] = useState('');
	const [concept1, setConcept1] = useState('');
	const [concept2, setConcept2] = useState('');
	const [concept3, setConcept3] = useState('');
	const [concept4, setConcept4] = useState('');

	const [selectedPalabra, setSelectedPalabra] = useState(null);
	const [selectedPal, setSelectedPal] = useState(null);
	const respuestas = [
		{ from: 'Directivo', to: 'Baja habilidad y baja confianza.' },
		{ from: 'Delegador', to: 'Alta habilidad y alta confianza.' },
		{ from: 'Participativo', to: 'Habilidad moderada y motivación variable.' },
		{ from: 'Persuasivo', to: 'Alta habilidad y motivación estable.' },
	];

	const handleWordClick = (id, word) => {
		let array = connections;
		setSelectedPal(id);

		switch (id) {
			case 1:
				setBtn1('btn1');
				setSelectedPalabra('btn1');
				array[id - 1] = { from: word, to: '' };
				setConnections(array);
				break;
			case 2:
				setBtn2('btn2');
				setSelectedPalabra('btn2');
				array[id - 1] = { from: word, to: '' };
				setConnections(array);
				break;
			case 3:
				setBtn3('btn3');
				setSelectedPalabra('btn3');
				array[id - 1] = { from: word, to: '' };
				setConnections(array);
				break;
			case 4:
				setBtn4('btn4');
				setSelectedPalabra('btn4');
				array[id - 1] = { from: word, to: '' };
				setConnections(array);
				break;

			default:
				break;
		}
	};
	const handleConceptClick = (id, word) => {
		let array = connections;

		switch (id) {
			case 5:
				setConcept1(selectedPalabra);
				array[selectedPal - 1] = { from: array[selectedPal - 1][`from`], to: word };
				setConnections(array);
				break;
			case 6:
				setConcept2(selectedPalabra);
				array[selectedPal - 1] = { from: array[selectedPal - 1][`from`], to: word };
				setConnections(array);
				break;
			case 7:
				console.log(selectedPalabra);

				setConcept3(selectedPalabra);
				array[selectedPal - 1] = { from: array[selectedPal - 1][`from`], to: word };
				setConnections(array);
				break;
			case 8:
				setConcept4(selectedPalabra);
				array[selectedPal - 1] = { from: array[selectedPal - 1][`from`], to: word };
				setConnections(array);
				break;
			default:
				break;
		}

		setSelectedPalabra(null);
		setSelectedPal(null);
	};

	const arraysAreEqual = (arr1, arr2) => {
		if (arr1.length !== arr2.length) return false;
		return arr1.every((obj, index) => JSON.stringify(obj) === JSON.stringify(arr2[index]));
	};

	const siguiente = () => {
		if (arraysAreEqual(connections, respuestas)) {
			setRespuesta('pregunta4', connections, 1);
			console.log('si');

			sumarPuntos(1);
		} else {
			setRespuesta('pregunta4', connections, 0);
			console.log('no');

			sumarPuntos(0);
		}
		cambiarPregunta(5);
	};

	return (
		<>
			<Container maxWidth='lg'>
				<Grid container justifyContent='center' alignItems='center' spacing={4}>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div className='pregunta'>
							<div className='num-pregunta'>4.</div>Relaciona el estilo de liderazgo con el nivel de madurez del colaborador:
						</div>
					</Grid>
				</Grid>
			</Container>
			<div ref={containerRef2} className='matching-container'>
				<div className='columns'>
					<div className='column words'>
						{/* {words.map((word, index) => (
							<div key={index} id={`${word}`} className='word' onMouseDown={() => (connections.length < 4 ? handleStartConnection(`${word}`) : null)}>
								{word}
							</div>
						))} */}
						<div className={`word ${btn1}`} onClick={() => handleWordClick(1, 'Directivo')}>
							Directivo
						</div>
						<div className={`word ${btn2}`} onClick={() => handleWordClick(2, 'Delegador')}>
							Delegador
						</div>
						<div className={`word ${btn3}`} onClick={() => handleWordClick(3, 'Participativo')}>
							Participativo
						</div>
						<div className={`word ${btn4}`} onClick={() => handleWordClick(4, 'Persuasivo')}>
							Persuasivo
						</div>
					</div>
					<div className='column concepts'>
						{/* {concepts.map((concept, index) => (
							<div key={index} id={`${concept}`} className='concept' onMouseUp={() => (connections.length < 4 ? handleEndConnection(`${concept}`) : null)}>
								{concept}
							</div>
						))} */}
						<div className={`concept ${concept1}`} onClick={() => handleConceptClick(5, 'Alta habilidad y alta confianza.')}>
							Alta habilidad y alta confianza.
						</div>
						<div className={`concept ${concept2}`} onClick={() => handleConceptClick(6, 'Baja habilidad y baja confianza.')}>
							Baja habilidad y baja confianza.
						</div>
						<div className={`concept ${concept3}`} onClick={() => handleConceptClick(7, 'Alta habilidad y motivación estable.')}>
							Alta habilidad y motivación estable.
						</div>
						<div className={`concept ${concept4}`} onClick={() => handleConceptClick(8, 'Habilidad moderada y motivación variable.')}>
							Habilidad moderada y motivación variable.
						</div>
					</div>
				</div>
			</div>
			<Container maxWidth='lg'>
				<Grid container justifyContent='center' alignItems='center' spacing={4}>
					<Grid item xs={12} sm={12} md={12} lg={12}>
						<div className='siguiente' onClick={() => siguiente()}>
							Siguiente
						</div>
					</Grid>
				</Grid>
			</Container>
		</>
	);
}
